<template>
  <label class="block">
    <span v-if="label" class="mb-1 block text-[10px] font-bold uppercase tracking-widest text-[#1c4848]/45">{{ label }}</span>
    <textarea
      ref="area"
      :value="modelValue"
      :placeholder="placeholder"
      :dir="arabic ? 'rtl' : 'auto'"
      :lang="arabic ? 'ar' : undefined"
      rows="1"
      class="block w-full resize-none rounded-lg bg-transparent px-2 py-1.5 outline-none transition-colors"
      :style="center ? 'text-align:center' : null"
      :class="[arabic ? 'font-quran text-2xl leading-[2]' : '', inputClass, onDark ? 'placeholder:text-white/60 hover:bg-white/10 focus:bg-black/25 focus:ring-1 focus:ring-white/40' : 'placeholder:text-[#1c4848]/30 hover:bg-[#1c4848]/[0.03] focus:bg-white focus:ring-1 focus:ring-[#1c4848]/20']"
      :disabled="readOnly"
      @input="onInput"
    ></textarea>
  </label>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  arabic: { type: Boolean, default: false },
  inputClass: { type: String, default: 'text-sm text-[#1c4848]' },
  readOnly: { type: Boolean, default: false },
  onDark: { type: Boolean, default: false },
  center: { type: Boolean, default: false },
});
const emit = defineEmits(['update:modelValue']);

const area = ref(null);

function grow() {
  if (!area.value) return;
  area.value.style.height = 'auto';
  area.value.style.height = `${area.value.scrollHeight}px`;
}

function onInput(event) {
  emit('update:modelValue', event.target.value);
  grow();
}

// The page opens hidden until it has loaded, and a hidden field measures zero.
let observer = null;
let width = 0;

onMounted(() => {
  grow();
  observer = new ResizeObserver(([entry]) => {
    if (entry.contentRect.width !== width) {
      width = entry.contentRect.width;
      grow();
    }
  });
  observer.observe(area.value);
});
onBeforeUnmount(() => observer?.disconnect());
watch(() => props.modelValue, () => nextTick(grow));
</script>
